import React, { useState, useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';
import { Checkbox } from 'tea-component';
import RangePicker from '@gp/components/GeneralRangePicker';
import GeneralSelectFilter, { FilterItemType } from '@gp/components/GeneralSelectFilter';
import { RANGE_PICKER_TYPE, RANGE_PICKER_TYPES } from '../../../../constants';

import type { IRecord } from '@gp/types/global';

import './index.scss';

interface IFilterProps extends IBaseProps {
  loading?: boolean;
  dateRange?: [string, string] | null;
  date?: string;
  options?: FilterItemType[];
  onChange?: (studio: string[], project: string[], date: string, ym: string[], handleFilterName: string) => void;
}

const DEFAULT_OPTIONS: FilterItemType[] = [];

const Filter: React.FC<IFilterProps> = (props) => {
  const { loading = true, dateRange = null, date: dateProps, options = DEFAULT_OPTIONS, onChange } = props;

  const [selectValues, setSelectValues] = useState<IRecord<string[]>>({});
  const [selectYM, setSelectYM] = useState(['1']);
  const [date, setDate] = useState('');

  const handleSelectFilterChange = useMemoizedFn((payload, handleFilterName) => {
    setSelectValues(payload);
    onChange?.(payload?.studio || [], payload?.project || [], date, selectYM, handleFilterName);
  });

  const handleYMChange = useMemoizedFn((value: string[]) => {
    setSelectYM(value);
    onChange?.(selectValues?.studio || [], selectValues?.project || [], date, value, 'ym');
  });

  const handleDateFilterChange = useMemoizedFn((payload?: string) => {
    const newDate = payload || '';
    setDate(newDate);
    onChange?.(selectValues?.studio || [], selectValues?.project || [], newDate, selectYM, 'date');
  });

  useEffect(() => {
    if (loading) return;
    if (!date && !!dateProps) {
      setDate(dateProps);
    }
  }, [loading, dateProps]);

  return (
    <section className="dbg-studio-monthly-report-live-title-card-filter">
      <GeneralSelectFilter
        // matchButtonWidth={false}
        options={options}
        onChange={handleSelectFilterChange}
      />
      <RangePicker
        disabled={loading}
        isRange={false}
        type={RANGE_PICKER_TYPE}
        typeList={RANGE_PICKER_TYPES}
        // @ts-ignore
        dateRange={dateRange}
        value={date}
        onChange={handleDateFilterChange}
      />
      <Checkbox.Group className="gp-live-title-card-filter-ym-selector" value={selectYM} onChange={handleYMChange}>
        <Checkbox name="1">YoY</Checkbox>
        <Checkbox name="2">MoM</Checkbox>
      </Checkbox.Group>
    </section>
  );
};

export default React.memo(Filter);
